import { AdUnit } from '../staticCommercial/types';
import { isTrackingDev } from '../utils/trackingEnv';

const adUnitPath = isTrackingDev
  ? '/19784602/tv2-addressabletv/Beta/beta_pause_ad_1'
  : '/19784602/tv2-addressabletv/HVOD/Chromecast/pause_1';

export const chromecastAdUnit: AdUnit = {
  adUnitPath,
  size: [800, 450],
  divId: 'div-gpt-ad-1635319222371-0',
};
